// extracted by mini-css-extract-plugin
module.exports = {"participant":"BookingDetailDialog_participant__1bz_l","participantBadge":"BookingDetailDialog_participantBadge__1FhL_","quickInfo":"BookingDetailDialog_quickInfo__Qnmua"};